import React, { useCallback, useEffect, useState } from "react";
import { Form, Select, Input, Button, Col, message, Divider } from "antd";
import { MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
// import { allCompanyListing } from "services/redux/Reference/action";
import { debounce, isEmpty } from "lodash";
import { contactCompanyListing } from "services/remanentCalls";

const { Option } = Select;

const CurrencyDetails = ({
  fields,
  add,
  remove,
  errors,
  form,
  parentField,
}) => {
  const { allCurrencyListingResponse } = useSelector(
    (state) => state.reference
  );

  return (
    <>
      {fields.map((field) => (
        <div
          key={field.key}
          className="profiledetails__rowedit"
          style={{
            alignItems: "center",
            width: "100%",
            display: "flex",
            justifyContent: "space-between",
            marginBottom: "8px",
          }}
        >
          <Form.Item
            className="profiledetails__rowedit--label"
            name={[field.name, "id"]}
            fieldKey={[field.fieldKey, "id"]}
            rules={[
              {
                required: true,
                message: "Please select a currency!",
              },
            ]}
          >
            <Select
              size="small"
              showSearch
              placeholder="Select Currency"
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
              getPopupContainer={(trigger) => trigger.parentNode}
              onChange={(value, option) => {
                const updatedBidAmount = form
                  .getFieldValue([
                    "biddingCompany",
                    parentField.name,
                    "bidAmount",
                  ])
                  .map((item, index) => {
                    if (index === field.name) {
                      return {
                        ...item,
                        name: option.children,
                      };
                    }
                    return item;
                  });

                form.setFieldsValue({
                  biddingCompany: form
                    .getFieldValue("biddingCompany")
                    .map((item, index) => {
                      if (index === parentField.name) {
                        return {
                          ...item,
                          bidAmount: updatedBidAmount,
                        };
                      }
                      return item;
                    }),
                });
              }}
            >
              {allCurrencyListingResponse?.map(({ currencyId, abbvr }) => (
                <Option key={currencyId} value={currencyId}>
                  {abbvr}
                </Option>
              ))}
            </Select>
          </Form.Item>

          <div style={{ display: "none" }}>
            <Form.Item name={[field.name, "name"]}></Form.Item>
          </div>

          <Form.Item
            className="profiledetails__rowedit--data"
            name={[field.name, "amount"]}
            fieldKey={[field.fieldKey, "amount"]}
            rules={[
              {
                required: true,
                message: "Please input the amount!",
              },
            ]}
          >
            <Input size="small" placeholder="Enter Amount" autoComplete="off" />
          </Form.Item>

          {fields.length > 0 ? (
            <MinusCircleOutlined
              className="dynamic-delete-button"
              onClick={() => remove(field.name)}
              style={{ margin: "0 8px" }}
            />
          ) : null}
        </div>
      ))}

      <Col>
        <Form.Item>
          <Button
            type="dashed"
            onClick={() => add()}
            style={{ width: "100%" }}
            icon={<PlusOutlined />}
          >
            Add Currency Detail
          </Button>
          <Form.ErrorList errors={errors} />
        </Form.Item>
      </Col>
    </>
  );
};

const BiddingCompanyDetails = ({ fields, add, remove, errors, form }) => {
  const [value, setValue] = useState("");
  const [contactCompanyListingResponse, setContactCompanyListing] = useState(
    []
  );

  const fetchContactCompanyListing = useCallback(async (body) => {
    try {
      const resp = await contactCompanyListing(body);
      if (resp && resp.status === 200) {
        setContactCompanyListing(resp.data);
      }
    } catch (err) {
      message.error("Failed to fetch company listings");
    }
  }, []);

  const debouncedFetch = useCallback(
    debounce((value) => {
      if (!isEmpty(value)) {
        fetchContactCompanyListing({ contactSearch: value });
      }
    }, 800),
    [fetchContactCompanyListing]
  );

  useEffect(() => {
    debouncedFetch(value);
    return () => {
      debouncedFetch.cancel();
    };
  }, [value, debouncedFetch]);

  return (
    <>
      {fields.map((field) => (
        <div key={field.key}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              marginBottom: "8px",
            }}
          >
            <Form.Item
              className="form__group"
              name={[field.name, "companyInfoId"]}
              fieldKey={[field.fieldKey, "companyInfoId"]}
              label="Bidding Company"
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 24 }}
              rules={[
                {
                  required: false,
                  message: "Please input biddingCompany",
                },
              ]}
            >
              <Select
                mode="multiple"
                allowClear
                size="small"
                showSearch={true}
                onSearch={(value) => setValue(value)}
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                }
                getPopupContainer={(trigger) => trigger.parentNode}
                onChange={(value, option) => {
                  const selectedData = option.map((opt) => ({
                    id: opt.value,
                    name: opt.children,
                    type: 0,
                  }));
                  form.setFieldsValue({
                    biddingCompany: fields.map((fieldItem, index) => {
                      if (index === field.name) {
                        return {
                          ...form.getFieldValue("biddingCompany")[index],
                          companyInfo: selectedData,
                        };
                      }
                      return form.getFieldValue("biddingCompany")[index];
                    }),
                  });
                }}
              >
                {contactCompanyListingResponse.length > 0
                  ? contactCompanyListingResponse?.map((company) => (
                      <Option
                        value={company.id}
                        key={company.companyName}
                        label={company.companyName}
                      >
                        {company.companyName}
                      </Option>
                    ))
                  : form !== undefined &&
                    form?.getFieldValue("biddingCompany") !== undefined &&
                    form?.getFieldValue("biddingCompany")[field.name]
                      ?.companyInfo !== undefined &&
                    form
                      ?.getFieldValue("biddingCompany")
                      [field.name]?.companyInfo?.map((company) => (
                        <Option
                          value={company.id}
                          key={company.name}
                          label={company.name}
                        >
                          {company.name}
                        </Option>
                      ))}
              </Select>
            </Form.Item>
            {fields.length > 0 ? (
              <MinusCircleOutlined
                className="dynamic-delete-button"
                onClick={() => remove(field.name)}
                style={{ margin: "0 8px" }}
              />
            ) : null}
          </div>

          <Form.Item
            className="form__group"
            label="Diff With L1"
            name={[field.name, "diffAmountL1"]}
            fieldKey={[field.fieldKey, "diffAmountL1"]}
            labelCol={{ span: 24 }}
            wrapperCol={{ span: 24 }}
            rules={[
              {
                required: false,
                message: "Please input diffWithL1",
              },
            ]}
          >
            <Input />
          </Form.Item>

          <Form.Item
            className="form__group"
            label="Rank"
            name={[field.name, "rank"]}
            fieldKey={[field.fieldKey, "rank"]}
            labelCol={{ span: 24 }}
            wrapperCol={{ span: 24 }}
            rules={[
              {
                required: false,
                message: "Please input rank",
              },
            ]}
          >
            <Input />
          </Form.Item>

          <Form.Item
            className="form__group"
            label="Awarded"
            name={[field.name, "awardedYesOrNo"]}
            fieldKey={[field.fieldKey, "awardedYesOrNo"]}
            labelCol={{ span: 24 }}
            wrapperCol={{ span: 24 }}
            rules={[
              {
                required: false,
                message: "Please input awarded",
              },
            ]}
          >
            <Select size="small" defaultValue={"Yes"}>
              <Option key={"Yes"} value={"Yes"}>
                {"Yes"}
              </Option>
              <Option key={"No"} value={"No"}>
                {"No"}
              </Option>
            </Select>
          </Form.Item>

          <Form.Item
            className="form__group"
            label="Remarks"
            name={[field.name, "remarks"]}
            fieldKey={[field.fieldKey, "remarks"]}
            labelCol={{ span: 24 }}
            wrapperCol={{ span: 24 }}
            rules={[
              {
                required: false,
                message: "Please input remarks",
              },
            ]}
          >
            <Input />
          </Form.Item>
          <Form.List
            name={[field.name, "bidAmount"]}
            fieldKey={[field.fieldKey, "bidAmount"]}
          >
            {(currencyFields, currencyOps) => (
              <CurrencyDetails
                fields={currencyFields}
                add={currencyOps.add}
                remove={currencyOps.remove}
                errors={currencyOps.errors}
                form={form}
                parentField={field}
              />
            )}
          </Form.List>

          <Divider
            variant="dashed"
            style={{
              borderColor: "black",
            }}
            dashed
          />
        </div>
      ))}

      <Col>
        <Form.Item>
          <Button
            type="dashed"
            onClick={() => add()}
            style={{ width: "100%" }}
            icon={<PlusOutlined />}
          >
            Add Bidding Company Detail
          </Button>
          <Form.ErrorList errors={errors} />
        </Form.Item>
      </Col>
    </>
  );
};

export default BiddingCompanyDetails;
